import { createStore } from '../.'
import { ICP_ICP_ID } from '../../constants/tokenIds'
import type { StateStorage } from 'zustand/middleware'

interface UserTokenStore {
  savedTokens: { [key: string]: string[] }
  setSavedTokens: (walletId: string, tokenIds: string[]) => void
  toggleToken: (walletId: string, tokenId: string) => void
  addToken: (walletId: string, canisterId: string) => void
  isTokenAdded: (walletId: string, token: { id: string }) => boolean
}

export const createUserTokensStore = (storage: StateStorage) =>
  createStore<UserTokenStore>(
    storage,
    (set, get) => ({
      savedTokens: {},
      setSavedTokens(walletId, tokenIds) {
        const { savedTokens } = get()
        set({ savedTokens: { ...savedTokens, [walletId]: tokenIds } })
      },
      toggleToken(walletId, tokenId) {
        const currentTokens = get().savedTokens
        const existingWalletTokens = currentTokens[walletId] || []

        if (existingWalletTokens.includes(tokenId)) {
          set({
            savedTokens: {
              ...currentTokens,
              [walletId]: currentTokens[walletId].filter((token) => token !== tokenId),
            },
          })
        } else {
          set({
            savedTokens: {
              ...currentTokens,
              [walletId]: [...existingWalletTokens, tokenId],
            },
          })
        }
      },
      addToken(walletId, tokenId) {
        const currentTokens = get().savedTokens

        const existingWalletTokens = currentTokens[walletId] || []

        if (existingWalletTokens.includes(tokenId) || tokenId === ICP_ICP_ID) return

        set({
          savedTokens: {
            ...currentTokens,
            [walletId]: [...existingWalletTokens, tokenId],
          },
        })
      },
      isTokenAdded(walletId, { id }) {
        const currentTokens = get().savedTokens

        const existingWalletTokens = currentTokens[walletId] || []

        return id === ICP_ICP_ID || existingWalletTokens.includes(id)
      },
    }),
    {
      persist: {
        name: 'userTokens',
        version: 0,
      },
    }
  )
